import { createSignal } from '@verclam/pulsar';

/** The key of the section tab currently shown. `''` is a legitimate value: it addresses the
 * server-placed "Général" section (`DocumentSectionView.key === ''`), never an absence of choice. */
const activeSectionSignal = createSignal<string>('');

export const setActiveSection = (sectionKey: string): void => {
	activeSectionSignal.value = sectionKey;
};

export default activeSectionSignal;
